import { CreateTrialActionDocument } from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

const useCreateTrialAction = () => {
  const [createTrialAction, { loading }] = useMutation(CreateTrialActionDocument, {
    extractorFn: (data) => data.marketingMutations.createMarketingTrialAction,
  })

  return {
    loading,
    create({
      droppedBillingStep,
      reason,
      reasonOther,
    }: {
      droppedBillingStep: boolean
      reason?: string | undefined
      reasonOther?: string | undefined
    }) {
      return createTrialAction({
        variables: {
          droppedBillingStep,
          reason,
          reasonOther,
        },
      })
    },
  }
}

export default useCreateTrialAction
